export const ORG_LOOKUP_API_URL = "https://org-lookup-poc.onrender.com";
export const ORG_LOOKUP_API_KEY =
  process.env.REACT_APP_ORG_LOOKUP_API_KEY ?? "";

/** Comma-separated org names. When set, only these orgs are checked. */
export const ORG_WHITELIST = (process.env.REACT_APP_ORG_WHITELIST ?? "")
  .split(",")
  .map((org) => org.trim())
  .filter(Boolean);
